module.exports = __webpack_public_path__ + "img/estatus_bien.ec2456d1.png";